import { render, staticRenderFns } from "./RoomWidget.vue?vue&type=template&id=af8feb3a"
import script from "./RoomWidget.vue?vue&type=script&lang=js"
export * from "./RoomWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports